import { render, staticRenderFns } from "./aivision.vue?vue&type=template&id=c9a59a00&scoped=true"
import script from "./aivision.vue?vue&type=script&lang=js"
export * from "./aivision.vue?vue&type=script&lang=js"
import style0 from "./aivision.vue?vue&type=style&index=0&id=c9a59a00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a59a00",
  null
  
)

export default component.exports